import { render, staticRenderFns } from "./BrokerDeal.vue?vue&type=template&id=b1522fba"
import script from "./BrokerDeal.vue?vue&type=script&lang=js"
export * from "./BrokerDeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports